import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { IBetslip } from '../../../../../bet-generation/models';
import { IncorrectOptionsCountPreCheckError } from '../../../../errors/pre-check/incorrect-options-count-pre-check-error';
import { ErrorDetailsSpecifier } from '../../../../errors/pre-check/pre-check-error';
import { SystemBetValidationContext } from '../../../../models/models';
import { ISystemBetBetslipValidator } from '../validators';

@Injectable()
export class SystemBetIncorrectOptionsCountValidator implements ISystemBetBetslipValidator<IncorrectOptionsCountPreCheckError> {
    static MIN_SYSTEM_AVAILABLE_PICKS = 3;
    static MIN_SYSTEM_WITH_BANKER_PICKS = 2;
    static MAX_SYSTEM_WITH_BANKER_PICKS = 12;
    static MAX_RACE_PICKS_COUNT_IN_SYSTEM = 3;

    constructor(private config: BetslipConfig) {}

    validate(_: IBetslip, context: SystemBetValidationContext): IncorrectOptionsCountPreCheckError[] {
        const totalPicksCount = context.totalPicksCount;

        if (totalPicksCount < this.config.minSystemBets) {
            return [new IncorrectOptionsCountPreCheckError(this.config.minSystemBets, totalPicksCount, ErrorDetailsSpecifier.MinSystemBetsCount)];
        }

        const systemPicksCount = context.validSystemPicksCount;
        const bankerPicksCount = context.validBankerPicksCount;

        // when picks are more than max
        if (systemPicksCount > this.config.maxSystemBets) {
            return [new IncorrectOptionsCountPreCheckError(this.config.maxSystemBets, systemPicksCount, ErrorDetailsSpecifier.SelectMaxSystemBets)];
        }

        if (bankerPicksCount === 0) {
            if (systemPicksCount < this.config.minSystemBets) {
                return [
                    new IncorrectOptionsCountPreCheckError(this.config.minSystemBets, systemPicksCount, ErrorDetailsSpecifier.SelectMinSystemBets),
                ];
            }

            return [];
        }

        if (systemPicksCount < SystemBetIncorrectOptionsCountValidator.MIN_SYSTEM_WITH_BANKER_PICKS) {
            // when has banker picks we should have at least 2 non banker picks
            return [
                new IncorrectOptionsCountPreCheckError(
                    SystemBetIncorrectOptionsCountValidator.MIN_SYSTEM_WITH_BANKER_PICKS,
                    systemPicksCount,
                    ErrorDetailsSpecifier.SelectMinSystemBetsBanker,
                ),
            ];
        }

        const validPicksCount = systemPicksCount + bankerPicksCount;

        if (validPicksCount > SystemBetIncorrectOptionsCountValidator.MAX_SYSTEM_WITH_BANKER_PICKS) {
            // maximum picks banker and system with banker available is 12
            return [
                new IncorrectOptionsCountPreCheckError(
                    SystemBetIncorrectOptionsCountValidator.MAX_SYSTEM_WITH_BANKER_PICKS,
                    validPicksCount,
                    ErrorDetailsSpecifier.SelectMaxSystemBetsBanker,
                ),
            ];
        }

        return [];
    }
}
